<template>
	<div class='content'>
		<van-nav-bar
			   title="输入信息提交"
			   left-text=""
			   right-text=""
			   left-arrow
			   @click-left="onClickLeft"
			  @click-right="onClickRight"
			/>
	   <van-cell-group class="box">
		  <van-field
		  	  readonly
		  	  required
			  clickable
			  name="calendar"
			  v-model="timeDate"
			  label="游玩日期"
			  placeholder="点击选择日期"
			  left-icon="underway-o"
		      class='icon_color1'
			  @click="showCalendar = true"
			/>
			<van-calendar v-model="showCalendar" @confirm="onConfirm" />
		  <van-field
		    v-model="name"
		    clearable
		    label="游客姓名"
		    left-icon="manager"
		    required
		    placeholder="请输入姓名"
		    class='icon_color1'
		  />
		  
		  <van-field
		    v-model="phone"
		    clearable
		    required
		    label="手机号码"
		    left-icon="phone-circle"
		    placeholder="请输入电话号码"
		    class='icon_color2'
		  />
		  <van-field
		    v-model="ID_card"
		    clearable
		    required
		    label="身份证号"
		    left-icon="debit-pay"
		    placeholder="请输入身份证"
		     class='icon_color2'
		  />
		  <van-field
			   readonly
			   required
			   clickable
			   left-icon="underway-o"
			   label="预约时段"
			   class='icon_color1'
			   v-model ="valuetime"
			  placeholder="选择时间段"
			  @focus="valuetime_=true"
			/>
		   <van-action-sheet v-model="valuetime_"  :round ="false" :actions="datatime" @select="onSelect">
			</van-action-sheet >
			
		  <van-field
		  	v-if="hide"
		  	readonly
		    v-model="Arealist"
		    clearable
		    required
		    label="选择地区"
		    left-icon="comment"
		    placeholder="选择所在省市区"
		    @click="toSelect"
		     class='icon_color2'
		  />
		 <van-field
		 	v-if="hide"
		    v-model="Area_"
		    clearable
		    required
		    label="详细地址"
		    left-icon="bars"
		
		    placeholder="街道门牌,楼层房间号等"
		    class='icon_color2'
		  />
		<!-- <van-button type="info" @click="toSelect">请选择地址</van-button>-->
		 
        <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
            <van-area @cancel="cancelFn" :area-list="areaList" @confirm="confirmFn"
            :columns-placeholder="['请选择', '请选择', '请选择']" title="选择所在省市区" />
        </van-popup>
        
		</van-cell-group>
		
		
		<div class="box_visit">
		
			<!--<p>
			    <van-icon name="bars" />
				订单：{{order}}
				</p>-->
		    <p ><van-icon name="bars"  color="#1989fa"/>
				可预约人数：{{numlist_}}
			</p>
			<p v-if="hidelist"><van-icon name="balance-o"  color="#4fc08d"/>
				金额：{{total}}
			</p>
			<p>
				<van-icon name="bars"  color="#1989fa"/>
				数量：{{numlist}}
			</p>
			
		</div>
	    
		<!--<van-tabbar v-model="active">
		  
		   <van-tabbar-item icon="home-o"><router-link to="/wx_ticketIndex" class="router" >购票首页</router-link></van-tabbar-item>
		   <van-tabbar-item icon="search"><router-link to="/wx_ticketOrder" class="router activerouter">我的订单</router-link></van-tabbar-item>
		   <van-tabbar-item icon="setting-o"><router-link to="/wx_ticketUser" class="router">个人中心</router-link></van-tabbar-item>
		</van-tabbar>-->
		<!--<van-submit-bar  button-text="提交支付" :disabled="isDisable"  @submit="onSubmit">-->
		<van-submit-bar  button-text="提交预约" :disabled="isDisable"  @submit="onSubmit">
		  <template >
		  	 <div id="numlist" >
		  	 	
		  	 	 <van-row >
				  	  <van-col span="24">
				  	  	 <van-col span="12">
				  	 	 <span style="margin-left: 3px;">数量:{{numlist}}</span>
				  	 	  </van-col>
				  	     <van-col span="12">
					   	    <span class="total">合计:{{total}}</span>
					   	  </van-col>
	 	    	    </van-col>
			   </van-row>
		  	
	 	    	 
 	    	 </div>
		  </template>
		</van-submit-bar>
	</div>
</template>

<script>
import { areaList } from '@vant/area-data';
 
  export default {
  data () {
    return {
    	/*Page({
		  data: {
		    areaList,
		  },
		});*/
		
		hide1: false,
		datatime:[],
        showtime: '',
		valuetime: '',
        valuetime_: false,
        
		Area_:'',
		Arealist:'',
		show: false,
        areaList:areaList,
		searchResult:[],
    	hidelist:false,
    	hide_:false,
    	 numlist_:'',
    	 isDisable:false,
    	 order:'',
    	 total:'',
    	 numlist:'',
    	 totala:'',
    	 numlista:'',
    	 timeDate:'',
    	 currentDate: new Date(),
    	 phone:'',
   	     ID_card: '',
   	     name :"",
	     message:'',
	     isLoadingShow: true,
    	 hide:false,
         loading: false,
	     finished: false,
         show: false,
         className: '',
         showCalendar: false,
         id:"",
         limitCount:'',
         timestart:'',
         timeend:'',
	    }
    },
    mounted(){
    	this.time();
    	//this.onLoadtime();
    	this.columns()
    },
	methods: {
     onSelect(item){
			this.valuetime_=false;
			this.valuetime=item.name;
			this.id=item.id;
			this.timestart=item.timestart;
			this.timeend=item.timeend;
		    this.onLoadtime();
		},
	 columns(){
	   this.$axios({
        url: "/api/appointmentConfig",
        method: "get",
        params: {
          pageItems: 999, //每页显示的条数
          pageNumber: 1, //页数
         
        }
      })
        .then(res => {
        	console.log(res.data)
            var data = res.data[0];
            this.datatime = [];
            for (const i in data) {
          	  let start = data[i].startPeriod.substring(0, 2)+':'+data[i].startPeriod.substring(2, 4);
              let end = data[i].endPeriod.substring(0, 2)+':'+data[i].endPeriod.substring(2, 4);
              let name =start+"-"+ end;
        	  this.datatime.push({
              id: data[i].id,
              name :name,
              timestart:start,
              timeend:end,
              limitCount:data[i].limitCount,
            
            });
          }
        
        
        })
        .catch(err => {
          console.log(err);
        });
    
		},
		
	    toSelect() {
                this.show = true;
            },
            confirmFn(value) {
                this.show = false;
                let a1 = value[0].name;
                if(a1 ==""){
                	return
                }
                let a2 = value[1].name;
                 if(a2 ==""){
                	return
                }
                let a3 = value[2].name;
                if(a3 ==""){
                	return
                }
                this.Arealist = a1+a2+a3;
            },
            cancelFn() {
                this.show = false;
            },
		onLoadtime() {
		 	let time1 = this.timeDate +' '+ this.timestart;
			let time2 = this.timeDate +' '+ this.timeend;
			let id =this.id;
		 	
		 	this.$axios({
		            url: "/api/sell/getRemainTicketCount",
		            method: "post",
		            data: {
		            	
		                startTime:time1,
		                endTime:time2,
						        appointmentID:id,
		            },
		            headers: {
		              "Content-Type": "application/json; charset=utf-8"
		            }
		            })
			    	.then(res => {
			    		console.log(res.data)
			    	    this.numlist_=res.data.remainTicketCount;
			    	})
    			  .catch(err => {
	              console.log(err);
	              this.$notify({ type: 'warning', message: '获取不到可预约人数' });
		     
	        });
	          
	       
	    },
	    onLoad() {
	        this.loading = false;
			this.finished = true;
	       
	    },
	    onClickLeft(){
			this.$router.push({ path: "/mn_ticketList" });
		},
		onClickRight(){},
	
		 // 选项格式化函数
		 onSubmit(){
		
		 	
		 	this.ticketlist=[];
		 	this.isDisable = true ;
			    setTimeout(() => {
			     this.isDisable = false
			    }, 1000)	
		 	let name =this.name;
		 	let phone =this.phone;
		 	let ID_card =this.ID_card;
		 	if(name==""){
	      	 this.$notify({ type: 'warning', message: '请输入游客姓名' });
			 return;
	        }	
      		if(name.length>12){
	      	 this.$notify({ type: 'warning', message: '输入姓名不能大于12个字符' });
			return;
	        }
      		if(phone==""){
		      	this.$notify({ type: 'warning', message: '请输入电话号码' });
				return;
		      }
      	    if( (!(/^[1][345789]\d{9}$/).test(phone) || !(/^[1-9]\d*$/).test(phone) || phone.length !== 11) ){
		      	this.$notify({ type: 'warning', message: '电话号码不符合规格' });
				return;
		      }	
			
			if(ID_card ==""){
	      		this.$notify({ type: 'warning', message: '请输入身份证号码' });
		        return;
		      }	
		     let valuetime =this.valuetime;
		     if(valuetime==""){
		     		this.$notify({ type: 'warning', message: '请选择预约时段' });
		        return;
		     }
		     let Arealist =this.Arealist;
			// if(Arealist ==""){
			// 		this.$notify({ type: 'warning', message: '请选择地区' });
		  //      return;
			// }
			 var Area =this.Area_;
			 
			// if(Area ==""){
			 //	this.$notify({ type: 'warning', message: '请填写详细地址' });
		   //     return;
			// }
		     let returnParam  = this.ID_cardlist(ID_card);
			 let isPass = returnParam.isPass;
			if(isPass==false){this.$notify({ type: 'warning', message: '请输入正确的身份证号码' });   return;}
			 let people =this.numlist;
			 let numlist_=this.numlist_;
			 
			 var nowDate = new Date();
            var year = nowDate.getFullYear();
            var month = nowDate.getMonth() < 9 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
            var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
            var timelist = year + "-" + month + "-" + day;
	        let hour = nowDate.getHours(); // 时
		    hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
		    let minute = nowDate.getMinutes(); // 分
		    minute= minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
		    let timemin = hour + ":" + minute;
            if(timelist==this.timeDate){
		 		if(this.timeend<timemin){this.$notify({ type: 'warning', message: '预约的时间段已不在有效期内' });return;}
		 	}
            
			 if(people>numlist_){
		      	this.$notify({ type: 'warning', message: '预约人数的名额不够,请重新购票' });
		        return;
		      }
			let total= this.total;
		 	let storage=window.sessionStorage;
    		let openid = storage.getItem("openid")
    		let payWay ='10';
 		    if(total==0){
    			 var ticketArray =this.$route.query.ticketArray;
    			 let arr =ticketArray[0];
    			 let ticketTypeID=arr.ticketTypeID;
    			if(people>0){
    				this.$axios({
		            url: "/api/sell/wxSubmitOrder",
		            method: "post",
		            data: {
		            	 payWay:payWay,
	                     openid:openid,
					     orderAmount: total,
					     ticketTypeID:ticketTypeID,
				         ticketUserIDNum:ID_card,//身份证
					   
		            },
		            headers: {
		              "Content-Type": "application/json; charset=utf-8"
		            }
		            })
			    	.then(res => {
			    		console.log(res.data)
			    		 if(res.data.result_msg=="禁止来自中高风险地区通行"){
			    		 	 this.$notify({ type: 'warning', message: '身份证属于风险地区不能预约' });
			 					return;
			    		 }
			    	    let data =res.data.JSAPI_result;
			    	    if(res.data.result_msg==""){
			    	   	  this.order_list(data.orderID);
			    	   	  
			    	   }
			      })
    			}
    			
			    
    		}else{
    			var queryParam_={
    				total:"0.01",
    				payWay:"8",
    				ticketUserIDNum:"111111111",//身份证
    			};
    		var queryParam=	JSON.stringify(queryParam_)
    		let id="1";
    		wx.miniProgram.navigateTo({ //这将唤起小程序的原生页面
                    url:'/pages/wxPay/wxPay?id='+id+ '&queryParam='+queryParam
                })
		 	}
		 },
	  
	    order_list(orderID){
		    let thta =this;
    	    let storage=window.sessionStorage;
			var openid = storage.getItem("openid")
		    var ticketArray =thta.$route.query.ticketArray
      		var ID_card =thta.ID_card;
      		var name =thta.name;
      		var time ='';
      		var phone =thta.phone;
      		var total =thta.total;
	        /*var nowDate = new Date();
            var year = nowDate.getFullYear();
            var month = nowDate.getMonth() < 9 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
            var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
            var timelist = year + "-" + month + "-" + day;*/
			var touristResidence = this.Arealist +this.Area_;
		    let appointmentStartTime = this.timeDate +' '+ this.timestart;
			let appointmentEndTime = this.timeDate +' '+ this.timeend;
	        //ticketStartTime:time,//游玩时间
    		this.$axios({
				    url: "/api/sell/wxConfirmOrder",
				            method: "post",
				            data: {
				            	openid:openid,
				            	orderID:orderID,
				            	touristIDCardNum:ID_card,//身份证
				            	touristMobile:phone,//电话
				            	appointmentStartTime:appointmentStartTime,
				            	appointmentEndTime:appointmentEndTime,
				                touristName: name,//姓名
				                orderAmount:total,
				                ticketArray:ticketArray,//票数组
				                touristResidence:touristResidence,
				            },
				            headers: {
				              "Content-Type": "application/json; charset=utf-8"
			   }
			 		 }) .then(res => {
				              console.log(res.data);
				              if (res.data.orderID !== "" ) {
				                alert("预约成功");
				                this.$router.push({ path: "/mn_ticketOrderlist"});
				              } else {
				               /* this.$message({
				                  showClose: true,
				                  message: res.data.errMsg,
				                  type: "error",
				                  duration: 5000
				                });*/
				                 alert("预约失败");
				              }
				            })
				            .catch(err => {
				              console.log(err);
				              
				              alert("数据连接异常，预约失败 ，将回到购票页面");
				              
				                setTimeout(function (){
			        	
			       						 this.$router.push({ path: "/mn_ticketList"});
			        					}, 2000);
							
				               
				            });
    		
		 },
		
        time(){
		       this.timeDate=this.dateFormat();
		       let storage=window.sessionStorage;
		       let openid = storage.getItem("openid")
    		   this.total =   this.$route.query.total;
    		   this.numlist =this.$route.query.numlist;
    		  }, 
		 onConfirm(date) {
		 	  var year=date.getFullYear();
	          var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1):date.getMonth() + 1;
              var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
		 	  this.timeDate = year+"-"+month+"-"+day
		 	  this.showCalendar = false;
		 	  this.valuetime="";
		 	   this.numlist_="";
		    //  this.onLoadtime() 
		    },    
		dateFormat() {//获取当前时间
		    	 var date=new Date();
		         var year=date.getFullYear();
		         var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1):date.getMonth() + 1;
	             var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
		        //var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
		       // var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
		        //var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
		        return year+"-"+month+"-"+day
        },   
	     ID_cardlist(ID_card){
	       //身份证号前两位代表区域
	       var city={
	                 11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",
	                 21:"辽宁",22:"吉林", 23:"黑龙江 ",
	                 31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",
	                 41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",
	                 50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",
	                 61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",
	                 71:"台湾",
	                 81:"香港",82:"澳门",
	                 91:"国外 "
	       };
	       //身份证格式正则表达式
	       var idCardReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
	       var errorMess = "";//错误提示信息
	       var isPass= true;//身份证验证是否通过（true通过、false未通过）
	
	    //如果身份证不满足格式正则表达式
	       if(!ID_card || !idCardReg.test(ID_card)){
	           errorMess = "您输入的身份证号格式有误！";
	           isPass= false;
	       }
	
	      //区域数组中不包含需验证的身份证前两位
	      else if(!city[ID_card.substr(0,2)]){
	           errorMess = "您输入的身份证地址编码有误！";
	           isPass= false;
	       }
	       else{
	           //18位身份证需要验证最后一位校验位
	           if(ID_card.length == 18){
	               ID_card = ID_card.split('');
	               //∑(ai×Wi)(mod 11)
	               //加权因子
	               var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
	               //校验位
	               var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
	               var sum = 0;
	               var ai = 0;
	               var wi = 0;
	               for (var i = 0; i < 17; i++)
	               {
	                   ai = ID_card[i];
	                   wi = factor[i];
	                   sum += ai * wi;
	               }
	               var last = parity[sum % 11];
	               if(parity[sum % 11] !== ID_card[17]){
	                   errorMess = "18身份证最后一位校验位验证有误！";
	                   isPass = false;
	               }
	           }
	       }
	       var returnParam = {
	           'errorMess' : errorMess ,
	           'isPass' : isPass 
	       }
	       return returnParam ;
	      },
         showPopup () {
	      this.show = true
	      this.isLoadingShow = true
	      setTimeout(() => {
	        this.isLoadingShow = false
	      }, 500)
    	},
    	
		 
	}
}
</script>

<style>
	#numlist span .button_{
	   display: inline-block;
	   width:40px;
	   height: 48px;
	   line-height: 48px;
	   font-size: 13px;
	   text-align: center;
	}
	#numlist span{
	   display: inline-block;
	   width:68px;
	   height: 48px;
	   line-height: 48px;
	   font-size: 13px;
	   text-align: center;
	}
	#numlist .total {
		text-align: left;
		 width:108px;
	}
	.icon_color1 i {
		color:#1989fa;
	}
	.icon_color2 i {
		color:#19c160;
	}
	.icon_color3 i {
		color:#07c160;
	}
	.icon_color4 i {
		color:#4fc08d;
	}
	.icon_color5 i {
		color:#2989fa;
	}
	.box_visit{
		width: 90%;
		margin-top:30px;
		margin-left: 5%;
		height: 100px;
		margin-bottom: 10px;
		
	}
</style>


// WEBPACK FOOTER //
// src/system/index/wechatlistmini/mn_ticketOrder.vue